import { render, staticRenderFns } from "./evalPage.vue?vue&type=template&id=3f722bd4"
import script from "./evalPage.vue?vue&type=script&lang=js"
export * from "./evalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports